var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AutocompleteInput } from "../AutocompleteInput";
export function SearchInput(props) {
    var paramKey = props.paramKey, value = props.value, setValue = props.setValue, gqlQuery = props.gqlQuery, icon = props.icon, label = props.label, _a = props.placeholder, placeholder = _a === void 0 ? label : _a, rest = __rest(props, ["paramKey", "value", "setValue", "gqlQuery", "icon", "label", "placeholder"]);
    var handleChange = function (e) {
        e.persist();
        setValue(e.target.value);
    };
    var handleSelect = function (val) {
        setValue(val);
    };
    return (_jsx(AutocompleteInput, __assign({}, rest, { name: paramKey, value: value, "aria-label": label, placeHolderText: placeholder, gqlQuery: gqlQuery, icon: icon, handleChange: handleChange, handleDropdownItemSelect: handleSelect })));
}
